import barra from "../../general/barra/barra.vue";
import barrais from "../../general/barrais/barrais.vue";
import foot from "../../general/foot/foot.vue";
import barrade from "../../general/barrade/barrade.vue";
import mixx from "../../../mixin/mixin.js";

export default {
  name: "resumenQrDni",
  mixins: [mixx],
  data() {
    return {
      msg: "-",
      loading: false,
      tbv: null,
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate()
      }
    };
  },
  mounted: function() {
    $("#cont_r").css("min-height", window.innerHeight - 101 + "px");
    this.tbv = $("#ventas").DataTable({
      paging: true,
      lengthChange: true,
      searching: true,
      ordering: true,
      info: true,
      order: [],
      autoWidth: true,
      orderCellsTop: true,
      fixedHeader: true,
      rowCallback: function(row, data, index) {}
    });
    $(".box").boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  computed: {
    reporte: function() {
      return (
        "/billeteras/gocuotas/liquidaciones?desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta
      );
    }
  },
  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post("/billeteras/gocuotas/liquidaciones", this.f_c)
        .then(response => {
          if (response.data.status == 1) {
            response.data.data.forEach(element => {
              element[4] = this.num_to_many(element[4]);
              element[5] = this.num_to_many(element[5]);
              element[6] = this.num_to_many(element[6]);
              element[7] = this.num_to_many(element[7]);
              element[8] = this.num_to_many(element[8]);
              element[9] = this.num_to_many(element[9]);
              element[10] = this.num_to_many(element[10]);
              this.tbv.row.add(element);
            });
          }
          this.tbv.draw();
          this.loading = false;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/reportes/goCuotasLiq/index.js